import React from 'react';
import { Card, Form, Button, Radio, Modal } from 'antd';
import { connect } from 'dva';
import { formItemLayout } from 'utils/utils.js';
import styles from './Index.less';
import AddressListTable from './AddressList/Index';
import UploadExcel from './UploadExcel/Index';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;

@connect(({ operationChargeItemPublishChargeItemSteps }) => ({
  chargeItemTarget: operationChargeItemPublishChargeItemSteps.step3NotificationChargeItemTarget,
  addressBook: operationChargeItemPublishChargeItemSteps.addressBook,
  tableDataSource: operationChargeItemPublishChargeItemSteps.step3NotificationTableDataSource,
  step3NotificationUploadResponse:
    operationChargeItemPublishChargeItemSteps.step3NotificationUploadResponse,
}))
@Form.create()
export default class Step3 extends React.Component {
  constructor(props) {
    super(props);

    this.handleChangeChargeItemTarget = this.handleChangeChargeItemTarget.bind(this);
    this.handlePrevStep = this.handlePrevStep.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { form, chargeItemTarget } = this.props;
    form.setFieldsValue({ chargeItemTarget });
  }

  handleChangeChargeItemTarget(e) {
    const { chargeItemTarget, form } = this.props;
    if (chargeItemTarget === '') {
      return this.props.dispatch({
        type: 'operationChargeItemPublishChargeItemSteps/saveStep3NotificationChargetItemTarget',
        chargeItemTarget: e.target.value,
      });
    }

    Modal.confirm({
      title: '提示',
      content: '是否切换缴费对象选择方式，确认后，当前数据 将被全部清空',
      onOk: () => {
        this.props.dispatch({
          type: 'operationChargeItemPublishChargeItemSteps/saveStep3NotificationChargetItemTarget',
          chargeItemTarget: e.target.value,
        });
      },
      onCancel: () => {
        form.setFieldsValue({
          chargeItemTarget:
            e.target.value === 'fromUploadExcel' ? 'fromAddressList' : 'fromUploadExcel',
        });
      },
    });
  }

  handlePrevStep() {
    this.props.dispatch({ type: 'operationChargeItemPublishChargeItemSteps/decrementCurrentStep' });
  }

  handleSubmit(e) {
    e.preventDefault();

    this.props.form.validateFields(err => {
      if (!err) {
        this.props.dispatch({
          type: 'operationChargeItemPublishChargeItemSteps/incrementCurrentStep',
        });
      }
    });
  }

  render() {
    const {
      chargeItemTarget,
      tableDataSource,
      addressBook: { tableList },
      step3NotificationUploadResponse,
    } = this.props;
    const { getFieldDecorator } = this.props.form;

    let disabled = chargeItemTarget !== '';
    switch (chargeItemTarget) {
      case 'fromAddressList':
        disabled = tableList.length === 0;
        break;
      case 'fromUploadExcel':
        disabled = tableDataSource.length === 0 || step3NotificationUploadResponse.valid !== true;
        break;
      default:
        break;
    }

    return (
      <Card bordered={false} className={styles.root}>
        <Form onSubmit={this.handleSubmit} className={styles.root}>
          <FormItem {...formItemLayout} label="收费对象">
            {getFieldDecorator('chargeItemTarget', {
              rules: [{ required: true, message: '请选择收费对象' }],
            })(
              <RadioGroup onChange={this.handleChangeChargeItemTarget}>
                <Radio value="fromAddressList">部门/按年级/班级/个人</Radio>
                <Radio value="fromUploadExcel">
                  上传收费名单（可按人员设置不同收费金额，交费形式必须为必交）
                </Radio>
              </RadioGroup>
            )}
          </FormItem>

          {chargeItemTarget === 'fromAddressList' && (
            <FormItem>
              <AddressListTable />
            </FormItem>
          )}

          {chargeItemTarget === 'fromUploadExcel' && (
            <FormItem>
              <UploadExcel initialDataSource={tableDataSource} />
            </FormItem>
          )}

          <FormItem className="operation-button-wrap">
            <Button onClick={this.handlePrevStep}>上一步</Button>
            <Button type="primary" htmlType="submit" disabled={disabled}>
              下一步
            </Button>
          </FormItem>
        </Form>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Operation/ChargeItem/PublishChargeItemSteps/Step3-Notification/Index.js